import type { PMSVendorData } from '@/types/pms.types';

/**
 * DV-3093 band-aid: every request that saves a PMS connection sends
 * `autoRefreshPropertyData: true`, although the UI no longer offers the toggle.
 *
 * Why it is still needed: the 12-hourly Autosync job (property-service's
 * `Autosync` branch, `AutoSyncMainClass`) picks the accounts it refreshes with
 * `findAllByAutoRefreshPropertyDataTrue()`, and property-service stores an
 * omitted value as `false` on create. Dropping the field from the payload would
 * therefore give every new connection a property list that never refreshes.
 * Forcing `true` also re-arms refresh for an account stored `false` the next
 * time its settings are saved.
 *
 * Proper fix: the job selects every connection (a paused one is already skipped
 * per entity). Once that ships, delete this helper, the field on `PMSVendorData`,
 * and the backend DTO field. Banked in docs/engineering-backlog.md (Backend asks,
 * "Autosync job selects every connection").
 */
export const withPropertyRefreshOn = <T extends PMSVendorData>(values: T): T => ({
  ...values,
  autoRefreshPropertyData: true,
});
